var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subtabs"},[_c('ul',{staticClass:"subtabs__list"},_vm._l((_vm.tabs),function(tab,idx){return _c('li',{key:idx,staticClass:"subtabs__item"},[_c('router-link',{staticClass:"subtabs__link",attrs:{"to":{ name: `User${tab.url}`}}},[_vm._v(" "+_vm._s(tab.title)+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }